<template>
    <div class="baseBody">
        <ScaleBox>
            <div class="main-wraper relative">
                <div id="container"
                    style="width: 100%;height: 100%;position: absolute;z-index: 100;left: 0px;top:48px;">
                </div>
                <div class="bodyZs"></div>
                <div class="bodyZs2"></div>
                <div class="custBodybg"></div>
                <div class="dateWeek">
                    <DynamicDate></DynamicDate>
                </div>
                <div class="fullBox">
                    <ScreenfullBox></ScreenfullBox>
                </div>
                <div class="baseTitleContent">
                    <div class="baseTitleMid">
                        <div class="top">
                            <div class="topLine">
                                <div class="title text-center base-font-60 text-white text-bold" style="font-size:45px; ">物流大数据面板</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="position: fixed;width:100%;left:0;top:0;z-index:999;pointer-events:none;">
                    <div class="flex align-center justify-between">
                        <div>
                            <div class="baseTitleLeft"></div>
                        </div>
                        <div>
                            <div class="baseTitleRight"></div>
                        </div>
                    </div>
                </div>
                <div style="z-index: 999;position: absolute;left: 0px;width: 20%;top:90px;">
                    <LeftContent></LeftContent>
                </div>
                <div class="midTopBox">
                    <div class="flex align-center  justify-center">
                        <div class="dataLeftBox">
                            <div class="flex align-end lrDataItem" style="margin-left: 20px;">
                                <div class="lrTitle ">今日订单数</div>
                                <div class="lrNum color1">{{item.dayOrderNum?item.dayOrderNum:'0'}}</div>
                            </div>
                            <div class="flex align-end lrDataItem">
                                <div class="lrTitle">今日运费</div>
                                <div class="lrNum color2">{{item.dayWorkerMoney?item.dayWorkerMoney:'0'}}</div>
                            </div>
                            <div class="flex align-end lrDataItem" style="margin-left: 20px;">
                                <div class="lrTitle">今日新增用户</div>
                                <div class="lrNum color3">{{item.memberNum?item.memberNum:'0'}}</div>
                            </div>
                        </div>
                        <div>
                            <div class="dataMidBox text-center">
                                <div class="base-font-56 text-bold midNum">{{item.orderNum?item.orderNum:'0'}}</div>
                                <div class="base-font-20 midTitle">总订单数据</div> 
                            </div>
                        </div>
                        <div class="dataRightBox">
                            <div class="flex align-end lrDataItem justify-end" style="margin-left: -20px;">
                                 <div class="lrNum color4">{{item.carNum?item.carNum:'0'}}</div>
                                <div class="lrTitle ">车辆总数</div>
                               
                            </div>
                            <div class="flex align-end lrDataItem justify-end">
                                <div class="lrNum color5">{{item.workerMoney?item.workerMoney:'0'}}</div>
                                <div class="lrTitle">总运费</div>
                                
                            </div>
                            <div class="flex align-end lrDataItem justify-end" style="margin-left: -20px;">
                                <div class="lrNum color6">{{item.allMemberNum?item.allMemberNum:'0'}}</div>
                                <div class="lrTitle">总用户</div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div style="z-index: 999;position: absolute;right: 0px;width: 20%;top:90px;">
                    <RightContent></RightContent>
                </div>

            </div>
        </ScaleBox>
        
        <el-dialog title="提示" :show-close="false" custom-class="custBoyModal" :visible.sync="dialogVisible" width="384px" >
            <div class="modalContent">
                <div class="text-center base-font-18 text-bold">车辆信息</div>
                <div class="margin-top-15 base-font-16"><soan class="text-bold">车牌号：</soan>{{carObj.carCode}}</div>
                <div class="base-font-16 margin-top-5"><soan class="text-bold">当前位置：</soan>{{carObj.address}}</div>
               
            </div>
            <div class="text-center margin-top-20" style="width:384px;">
                <i class="el-icon-circle-close base-font-30 text-white pointer" @click="handleClose"></i>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import AMapLoader from "@amap/amap-jsapi-loader";
    import DynamicDate from "../components/dynamicDate/index.vue";
    import ScreenfullBox from "../components/screenfull/index.vue";
    import ScaleBox from "../components/sacleBox/index.vue";
    import LeftContent from './components/leftContent.vue';
    import RightContent from './components/rightContent.vue';
    import {wlCenterData} from "@/api/api";
    export default {
        components: {
            LeftContent,
            RightContent,
            ScaleBox,
            DynamicDate,
            ScreenfullBox
        },
        data() {
            return {
                map: '',
                lineList: [],
                postionList: [],
                runMakerList: [],
                dialogVisible:false,
                item:{},
                carObj:{},
				timer:null
            }
        },
        mounted() {

            this.changeData();
			this.timer = setInterval(() => {
				  this.changeData();
				}, 60000); // 60秒 = 60000毫秒
        },
		beforeDestroy() {
		    // 组件销毁前清除定时器，避免内存泄漏
		    if (this.timer) {
		      clearInterval(this.timer);
		    }
		  },
        methods: {
            changeData() {
                let _self = this
                wlCenterData().then(res => {
                  _self.item=res.data
                  _self.postionList=res.data.carList
                  _self.$nextTick(function() {
                    _self.initAMap();
                  });
                });  
            },
            handleClose(){
                this.carObj={}
                this.dialogVisible=false
            },
            initAMap() {
                AMapLoader.load({
                    key: '18997a286e73c2d94837b10f89516387', // 高德地图API Key
                    version: '2.0', // 指定API版本
                    plugins: ["AMap.ControlBar", "AMap.ToolBar"], // 需要使用的插件
                    AMapUI: {
                        version: '1.1',
                        plugins: []
                    }
                }).then((AMap) => {
                    let longitude = '118.381805';
                    let latitude = '31.331352';
                    
                    // this.postionList = [];
                    // this.lineList.forEach((obj) => {
                    //     obj.pointList.forEach((pointObj) => {
                    //         this.postionList.push(pointObj);
                    //     })
                    // })
                    if (this.postionList.length > 0) {
                        longitude = this.postionList[0].longitude;
                        latitude = this.postionList[0].latitude;
                    }
                    this.map = new AMap.Map('container', {
                        rotateEnable: true,
                        pitchEnable: true,
                        zoom: 8,
                        rotation: -15,
                        viewMode: '3D', //开启3D视图,默认为关闭
                        zooms: [2, 20],
                        center: [longitude, latitude]
                    });
                    this.map.setMapStyle('amap://styles/darkblue');

                    this.setPostion(AMap);
                    this.setLinerList(AMap);
                    this.runMaker(AMap);

                }).catch(e => {
                    console.log(e);
                });
            },
            setPostion(AMap) {
                let pointList =this.item.carList;

                let _self=this
                _self.postionList.forEach((pointObj,index) => {
                    let title = '';
                    // if (pointObj.recordDateTime) {
                    //     title += "<br/>车牌号:" + pointObj.carCode;
                    // }
                     title += "<br/>车牌号:" + pointObj.carCode;
                    title =
                        "<div  style='background: url(https://31hs.oss-cn-beijing.aliyuncs.com/diy/diySwiper/202507180901582025071809015805810484022.png) top center no-repeat;background-size: 160px;height:45px;width:160px;height:45px;line-height:16px;color:#ffffff;font-size:16px;text-align:center;font-weight:bold'>" +
                        title + "</div>"
                    let point = new AMap.Marker({
                        position: [pointObj.longitude, pointObj.latitude],
                        icon: new AMap.Icon({
                            // 图标尺寸
                            size: new AMap.Size(65, 75),
                            // 图标的取图地址
                            image: 'https://31hs.oss-cn-beijing.aliyuncs.com/diy/diySwiper/202507180916332025071809163304230754227.png',
                            // 图标所用图片大小
                            imageSize: new AMap.Size(65, 75),
                        }),
                        offset: new AMap.Pixel(0, 0), //设置偏移量
                        label: {
                            direction: 'top',
                            content: title,
                            offset: new AMap.Pixel(0, -5),
                        }
                    });
                    point.on("click",function(){
                        _self.carObj=_self.postionList[index]
                        _self.dialogVisible=true
                    })
                    pointList.push(point);
                    // 创建圆
                    var circle = new AMap.Circle({
                        center: [pointObj.longitude, pointObj.latitude],
                        radius: pointObj.distance, //半径
                        fillColor: '#8cc4fc', // 填充颜色
                        fillOpacity: 0.3,
                        borderWeight: 5,
                        strokeColor: "#99999",
                        zIndex: 50,
                    })
                    pointList.push(circle);
                    // 缩放地图到合适的视野级别
                    //this.map.setFitView([ circle ])
                })
                this.map.add(pointList);
            },
            setLinerList(AMap) {
                this.lineList.forEach((obj) => {
                    this.setLiner(AMap, obj);
                })
            },
            showModal(){
                this.dialogVisible=true
            },
            setLiner(AMap, linerObj) {
                if (linerObj.recordList != null && linerObj.recordList.length > 0) {
                    // 绘制轨迹
                    let lineArr = [];
                    linerObj.recordList.forEach((obj) => {
                        lineArr.push([obj.longitude, obj.latitude])
                    })
                    this.runMakerList.push({
                        num: 0,
                        workerNames: linerObj.workerNames,
                        recordList: linerObj.recordList,
                        maker: null
                    });
                    // 绘制轨迹
                    new AMap.Polyline({
                        map: this.map,
                        path: lineArr,
                        showDir: true,
                        strokeColor: linerObj.sceneDescription, //线颜色
                        // strokeOpacity: 1,     //线透明度
                        strokeWeight: 6, //线宽
                        // strokeStyle: "solid"  //线样式
                    });

                }
            },
            runMaker(AMap) {
                setTimeout(() => {
                    let makerList = [];
                    this.runMakerList.forEach((obj, index) => {
                        //console.log("runMaker:"+this.runMakerList.length+";"+obj.num);
                        if (obj.maker != null) {
                            this.map.remove(obj.maker);
                        }
                        let maker = this.getRunMaker(AMap, obj.workerNames, obj.recordList[obj.num]);
                        obj.maker = maker;
                        makerList.push(maker);
                        obj.num += 1;
                        if (obj.num >= obj.recordList.length) {
                            obj.num = 0;
                        }
                        this.runMakerList.splice(index, 1, obj);
                    })
                    this.map.add(makerList);
                    this.runMaker(AMap);
                }, 2000)
            },
            getRunMaker(AMap, workerName, obj) {
                //设置maker
                let title = "巡逻人:" + workerName;
                if (obj.recordDateTime) {
                    title += "<br/>时间:" + obj.recordDateTime;
                }
                title =
                    "<div style='padding: 10px;font-size: 22px;border-radius: 10px;background-color: #008080;color: #ffffff;line-height: 28px;'>" +
                    title + "</div>"
                let makerPoint = new AMap.Marker({
                    position: [obj.longitude, obj.latitude],
                    icon: new AMap.Icon({
                        // 图标尺寸
                        size: new AMap.Size(60, 69),
                        // 图标的取图地址
                        image: 'https://zhab.oss-cn-beijing.aliyuncs.com/diy/diyGrid/202503051154062025030511540600890827879.png',
                        // 图标所用图片大小
                        imageSize: new AMap.Size(60, 69),
                    }),
                    offset: new AMap.Pixel(0, 0), //设置偏移量
                    label: {
                        direction: 'top',
                        content: title,
                        offset: new AMap.Pixel(0, -5),
                    }
                });

                return makerPoint;
            }
       
        }
    }
</script>


<style lang="scss">
    .amap-marker-label {
        background: none !important;
        border: none;
    }
    .pointer{cursor: pointer;}
    .custBoyModal{
        background: none;
            width:384px;
            .modalContent{
                width:384px;
                height: 244px;line-height:1.5;
                padding:50px 45px;box-sizing: border-box;
                margin: 0 auto;text-align: center;color:#FFFFFF;
                background: url('../assets/img/06.png') top left no-repeat;
                background-size: 100% 100%;
                text-align: left;
            }
    }
    .baseBody {
        width: 100%;
        height: 100vh;overflow: hidden;
        overflow: hidden;
        position: relative;
        font-size: 14px;
        background: #000208;
        position: relative;

        .main-wraper {
            user-select: none;
            width: 1920px;
            height: 1080px;
            margin: 0 auto;
            background: #02081a url('../assets/images/sytBg2.png') center no-repeat;
            background-size: cover;
            box-sizing: border-box;
        }

    }

    .dateWeek {
        position: absolute;
        top: 0;
        left: 0;
        width: 200px;
        height: 50px;
        color: #ffffff;
        z-index: 200;
    }

    .fullBox {
        position: absolute;
        top: 0;
        right: 0;
        width: 200px;
        height: 50px;
        color: #ffffff;
        z-index: 999;
    }

    .nyBaseHeadTop {
        width: 100%;
        height: 80px;
        background: url('../assets/images/titleBg.png') top center no-repeat;
        background-size: auto 80px
    }

    .base-headTit {
        font-size: 30px;
        font-weight: bold;
        box-sizing: border-box;
        padding-top: 24px;
    }

    .baseTitleLeft {
        width: 644px;
        height: 55px;
        background: url('../assets/images/titleLeft.png') top right no-repeat;
        background-size: auto 55px
    }

    .baseTitleRight {
        width: 644px;
        height: 55px;
        background: url('../assets/images/titleRight.png') top left no-repeat;
        background-size: auto 55px
    }

    .baseBody .baseTitleContent {
        width: 100%;
        height: 100px;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        z-index: 200;
    }

    .baseBody .baseTitleContent .baseTitleMid {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/headtitileBg3.png') top left no-repeat;
        background-size: auto 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .top {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/headtitileBg2.png') top left no-repeat;
        background-size: auto 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .topLine {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/titleBg4.png') top left no-repeat;
        background-size: auto 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .title {
        width: 402px;
        height: 70px;
        margin: 0 auto;
        font-size: 34px;
        font-weight: bold;
        line-height: 70px;
        background: url('../assets/images/headtitileBg1.png') top left no-repeat;
        background-size: auto 70px
    }

    .dataItem {
        width: 180px;
        height: 95px;
        line-height: 1;
        margin: 0 auto;
        text-align: center;
        color: #FFFFFF;
        background: url('../assets/img/04.png') top left no-repeat;
        background-size: 100% 100%;
        padding-top: 18px;
        box-sizing: border-box;

        .title {
            font-size: 18px;
            font-weight: bold;
        }

        .num {
            font-size: 41px;
            font-weight: bold;
            margin-top: 10px;
            color: #43eb93;

            &.yc {
                color: #ff8a00;
            }

            &.blue {
                color: #00d8ff;
            }

            &.purper {
                color: #c62bff;
            }

            &.red {
                color: #ff94a3;
            }

            s &.yellow {
                color: #fdc671;
            }
        }
    }
    .bgImg{
            width:1920px;
            height: 1080px;line-height:1;
            margin: 0 auto;text-align: center;color:#FFFFFF;
            background: url('../assets/img/bg.png') top left no-repeat;
            background-size: 100% 100%;position:fixed;left:0;top:0;z-index: 120;pointer-events: none;
    }
    .custBodybg{
        width:1920px;
        height: 1080px;position:fixed;left:0;top:0;z-index: 100;pointer-events: none;
         background: -webkit-radial-gradient(rgba(0,12,38,0) 35%,rgba(0,12,38,0.8) 60%,rgba(0,12,38,0.8) 5%); /* Safari 5.1 - 6.0 */
          background: -o-radial-gradient(rgba(0,12,38,0) 35%,rgba(0,12,38,0.8) 60%,rgba(0,12,38,0.8) 5%); /* Opera 11.6 - 12.0 */
          background: -moz-radial-gradient(rgba(0,12,38,0) 35%,rgba(0,12,38,0.8) 60%,rgba(0,12,38,0.8) 5%); /* Firefox 3.6 - 15 */
          background: radial-gradient(rgba(0,12,38,0) 35%,rgba(0,12,38,0.8) 60%,rgba(0,12,38,0.8) 5%); /* 标准的语法 */
    }
    // .dataItem{
    //     width:212px;
    //     height: 212px;line-height:1;
    //     margin: 0 auto;text-align: center;color:#FFFFFF;
    //     background: url('../assets/img/05.png') top left no-repeat;
    //     background-size: 100% 100%;
    //     padding-top:74px;box-sizing: border-box;
    //     .title{font-size: 18px;font-weight: bold;}
    //     .num{font-size:41px;font-weight: bold;margin-top:10px;color:#43eb93;
    //         &.yc{color: #ff8a00;}
    //         &.blue{color: #00d8ff;}
    //         &.purper{color: #c62bff;}
    //         &.red{color:#ff94a3;}
    //         &.yellow{color: #fdc671;}
    //     }
    // }
    .bodyZs{width: 400px;height:1020px;background: url('../assets/img/bodyzs2.png') top left no-repeat;position: fixed;
            background-size: 100% 100%;position:fixed;right:-250px;bottom:0;z-index:200;pointer-events: none;

            
            }
    .bodyZs2{left: -250px;width: 400px;height:1020px;background: url('../assets/img/bodyzs.png') top left no-repeat;position: fixed;
            background-size: 100% 100%;position:fixed;bottom:0;z-index:200;pointer-events: none;
            
            }
    .midTopBox{
        width:1190px;height:283px;color:#FFFFFF;
        background: url('../assets/img/xzbj.png') top left no-repeat;background-size: 100% 100%;z-index: 200;position: absolute;left:365px;top:90px;
        
    }
    .midTopBox .lrDataItem{height:90px;line-height: 90px;width:350px; text-align: center;}
    .midTopBox .lrDataItem+.lrDataItem{margin-top: 5px;}
    .midTopBox .lrDataItem .lrTitle{font-size:20px;width: 150px;}
    .midTopBox .lrDataItem .lrNum{font-weight: bold;font-size: 30px;}
    .midTopBox .lrDataItem .lrNum.color1{color:#00ff97;}
    .midTopBox .lrDataItem .lrNum.color2{color:#e9ff83;}
    .midTopBox .lrDataItem .lrNum.color3{color:#ff6593;}
    .midTopBox .lrDataItem .lrNum.color4{color:#a31fff;}
    .midTopBox .lrDataItem .lrNum.color5{color:#ff9c00;}
    .midTopBox .lrDataItem .lrNum.color6{color:#0698ff;}
    .midTopBox .dataRightBox{text-align: right;}
    
    // <div class="dataLeftBox"></div>
    // <div class="dataMidBox"></div>
    // <div class="dataRightBox"></div>
    .dataMidBox{width:280px;height:283px;text-align: center; box-sizing: border-box;padding-top:100px;box-sizing: border-box;position: relative;
        &::after{content:'';width: 280px;height:280px;background: url('../assets/img/xz.png') top left no-repeat;display: block;position: absolute;left:0;top:-5px;pointer-events: none;background-size: 280px;height: 280px;
            animation: rotateCircle 7s infinite linear;
            -webkit-animation: rotateCircle 7s infinite linear;
        }
    }
    .dataLeftBox{
        width:290px;height:283px;
    }
    .dataRightBox{
         width:290px;height:283px;text-align:right;
    }
    .base-font-56{font-size: 56px;}
    .base-font-20{font-size: 20px;}
    .dataMidBox .midNum{color: #00d8ff;}
    .dataMidBox .midTitle{margin-top:30px;}
</style>